'use client'

import { Card, CardHeader, CardContent, List, Divider } from '@mui/material'
import { capitalize } from 'lodash'
import { useOutletContext } from 'react-router'
import { renderListItem } from './helpers'

export default function PetCharacteristics() {
	const { profile }: any = useOutletContext()

	return (
		<Card>
			<CardHeader
				titleTypographyProps={{ variant: 'h6' }}
				title={`Just ${profile?.name}`}
			></CardHeader>
			<CardContent>
				<List disablePadding>{renderListItem('Activity Level', profile?.activityLevel)}</List>
				<Divider />
				<List>{renderListItem('Body', profile?.bodyCondition)}</List>
				<Divider />
				<List>{renderListItem('Temperment', profile?.temperment)}</List>
				<Divider />
				<List>{renderListItem('Eating Style', profile?.eatingBehavior)}</List>
				<Divider />
				<List>{renderListItem('Treats', capitalize(profile?.treats))}</List>
			</CardContent>
		</Card>
	)
}
